// extracted by mini-css-extract-plugin
export var filterIncDec = "_b0-0";
export var leftBorder = "_b0-1";
export var rightBorder = "_b0-2";
export var stringInput = "_b0-3";